import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import CircleChart from '../../Dashboard/CircleChart'
import * as PatientActions from '../../../state/actions/selected-patient'
import css from './patientCard.css'


class Reviews extends Component {
  componentDidMount() {
    const { id, getPatientReviews } = this.props
    getPatientReviews(id)
  }

  getCounts = () => {
    const { reviews } = this.props
    const totalCount = reviews.length
    const positiveCount = reviews.filter(review => (
      review.positive || review.stars > 3
    )).length
    const negativeCount = totalCount - positiveCount
    return {
      positive: positiveCount,
      negative: negativeCount,
      total: totalCount,
    }
  }

  render() {
    const { reviews } = this.props
    if (reviews.length === 0) return <div />
    const { positive, negative, total } = this.getCounts()
    const data = [
      { value: negative },
      { value: positive },
    ]
    return (
      <div className={css.reviews}>
        <div className={css.horizontalLine} />
        <span className={css.label}>Reviews</span>
        <div className={css.info}>
          <div className={css.circle}>
            <CircleChart
              data={data}
              primaryColor="#c1595c"
              secondaryColor="#89c063"
              height={120}
              width={120}
              innerRadius={0}
              outerRadius={60}
            />
          </div>
          <div className={css.stats}>
            <div className={css.positive}><span>{positive}</span> Positive {positive === 1 ? 'Review' : 'Reviews'}</div>
            <div className={css.negative}><span>{negative}</span> Negative {negative === 1 ? 'Review' : 'Reviews'}</div>
            <div className={css.total}><span>{total}</span> Total {total === 1 ? 'Review' : 'Reviews'}</div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ selectedPatient: { reviews } }) => ({
  reviews,
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({ ...PatientActions }, dispatch)
)

Reviews.propTypes = {
  id: PropTypes.string.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.object),
  getPatientReviews: PropTypes.func.isRequired,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Reviews)



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/Reviews.js